import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "m9.638 7.146-1.3-1.3a1.266 1.266 0 0 0-1.75 0 .24.24 0 0 1-.337 0L4.159 3.755a.24.24 0 0 1 0-.336 1.237 1.237 0 0 0 0-1.751l-1.3-1.3a1.24 1.24 0 0 0-1.75 0L.8.674a2.715 2.715 0 0 0-.367 3.38 20.4 20.4 0 0 0 5.519 5.52 2.73 2.73 0 0 0 3.381-.368l.31-.309a1.24 1.24 0 0 0-.005-1.751"
    }, null, -1)
  ]));
}
const phoneTelephone = { render };
export {
  phoneTelephone as default,
  render
};
//# sourceMappingURL=phone-telephone.svg.js.map
